<nav class="navbar navbar-expand-md bg-dark text-light justify-content-between sticky-top">
    <ul class="navbar-nav">
        <!-- Page title -->
        <a class="navbar-brand text-light text-weight-bolder hover-logo"><i class="fas fa-project-diagram"></i>
            {{logo}}</a>
    </ul>

    <!-- Search item -->
    <div class=" ml-4 d-flex justify-content-center w-25" action="/projects">
        <input #myInput class="form-control form-control d-inline-block w-75" type="text" placeholder="Search"
            (input)="filterProjects(myInput.value)" id="filter">
        <button class="btn btn-dark d-inline-block w-25">
            <i class="fas fa-search bg-dark text-light"></i>
        </button>

    </div>


    <ul *ngIf="identity.isUserAuthenticated() && identity.isUserAuthorized(userId)" class="navbar-nav mx-2 ">
        <!-- Dropdown -->
        <li class="nav-item d-inline-block mw-25">
            <div class="btn-group">
                <a class="btn btn-dark text-light rounded-circle mr-2 " (click)="router.navigate(['/'])"><i class="fas fa-angle-left"></i></a>
                <a class="btn btn-dark text-light" (click)="createProjectDisplay()">Create Project</a>
                <button class="btn btn-dark text-light dropdown-toggle"  data-toggle="dropdown">Account</button>
                <div class="dropdown-menu dropdown-menu-right bg-dark position-absolute">
                    <button class="btn btn-dark text-light w-100 d-flex justify-content-start" type="button" data-toggle="modal" data-target="#change">Change Password</button>
                    <button class="btn btn-dark text-light w-100 d-flex justify-content-start" (click)="deleteUser()">Delete Account</button>
                    <button class="btn btn-dark text-light w-100 d-flex justify-content-start" (click)="identity.logOut()">Log Out</button>
                </div>
            </div>
        </li>
    </ul>

    <ul *ngIf="identity.isUserAuthenticated() && !identity.isUserAuthorized(userId) " class="navbar-nav mx-2">
        <li class="nav-item d-inline-block">
            <a class="btn btn-dark text-light rounded-circle mr-2 " (click)="router.navigate(['/'])"><i class="fas fa-angle-left"></i></a>
            <a class="btn btn-dark" (click)="router.navigate(['/projects'], {queryParams:{userId:identity.getCurrentUserId()}})">My Page</a>
        </li>
    </ul>

    <ul *ngIf="!identity.isUserAuthenticated()" class="navbar-nav mx-2 ">
        <!-- Login -->
        <li class="nav-item d-inline-block mw-75 ">
            <a class="btn btn-dark text-light rounded-circle mr-2 " (click)="router.navigate(['/'])"><i class="fas fa-angle-left"></i></a>
            <button type="button" class="btn btn-dark" data-toggle="modal" data-target="#login">
                Log In
            </button>
        </li>
    </ul>
    

</nav>
<div *ngIf="startWaitingAnimation" class="progress sticky-top"  style="height: 0.2rem">
    <div class="progress-bar" id="progress"></div>
</div>
<!-- Used to put 3 card on a row -->
<main>
    <!-- Card content -->
    <div class="card shadow " *ngFor="let project of filteredProjects">

        <!-- Read mode -->
        <div *ngIf="project.projectId!=null; else elseBlock">
            <!-- Card image-->
            <div class="card-img-top bg-light" id="img">
                <img src={{imgdomain}}{{project.photo}}>
            </div>
            <!-- Popover -->
            <ng-template #popContent>
                <div class="btn-group-vertical">
                    <button type="button" class="btn btn-outline-primary" (click)="moveLR(project.position, 'l')">Move
                        <i class="fas fa-angle-left"></i></button>
                    <button type="button" class="btn btn-outline-primary" (click)="moveLR(project.position, 'r')">Move
                        <i class="fas fa-angle-right"></i></button>
                    <button type="button" class="btn btn-outline-primary"
                        (click)="deleteProject(project.projectId, project.photo)">Delete</button>
                </div>
            </ng-template>
            <a *ngIf="identity.isUserAuthenticated() && identity.isUserAuthorized(userId)" class="card-img-overlay badge badge-pill text-secondary" placement="bottom"
                [autoClose]="'outside'" [ngbPopover]="popContent">
                <i class="fa fa-ellipsis-v"></i>
            </a>
            <!-- Card title and description -->
            <div class="card-body">
                <h4 class="card-title">{{project.title}}</h4>
                <p class="card-text">{{project.description}}</p>
            </div>
            <!--Redirect to project button-->
            <div class="card-footer">
                <a (click)="router.navigate(['/infos'], {queryParams:{userId:userId, projectId:project.projectId}})" class="btn btn-outline-primary">See
                    Project</a>
            </div>
        </div>
        <!-- Edit mode -->
        <ng-template #elseBlock>
            <form *ngIf="identity.isUserAuthenticated() && identity.isUserAuthorized(userId)" [formGroup]="createProjectForm"
                (ngSubmit)="createProject(createProjectForm.value)" class="d-flex flex-column h-100"
                style="height: 35rem;">
                <div class="img-thumbnail bg-light" id="img">
                    <img *ngIf="selectedImage.file==null" class="img-fluid mb-1" src={{imgdomain}}{{defaultimg}}>
                    <img *ngIf="selectedImage.file!=null" class="img-fluid mb-1" src={{selectedImage.browserImg}}>
                </div>
                <div class="custom-file mb-3 ">
                    <input #imageInput type="file" accept="image/*" class="custom-file-input" id="customFile"
                        (change)="saveImage(imageInput)">
                    <label class="custom-file-label overflow-hidden"
                        for="customFile">{{selectedImage.placeholder}}</label>
                </div>

                <div class="form-group">
                    <input type="text" class="form-control" placeholder="Enter the project title" id="title"
                        formControlName="title">
                </div>
                <div class="form-group">
                    <textarea class="form-control" rows="6" placeholder="Enter the project description" id="description"
                        formControlName="description" style="resize:none;"></textarea>
                </div>
                <div
                    class="form-group form-check flex-fill d-flex  justify-content-between align-items-end  px-lg-3 px-sm-1 px-3">
                    <button type="submit" class="btn btn-success mh-50">Create</button>
                    <button class="btn btn-secondary justify-content-end mh-25"
                        (click)=closeCreationDisplay()>Cancel</button>
                </div>
            </form>
        </ng-template>
    </div>
</main>  

<!-- Appears when the user has no projects -->
<div *ngIf="userHasNoProjects && identity.isUserAuthenticated() && identity.isUserAuthorized(userId)" 
    class="d-flex flex-row align-items-center justify-content-center" id="wrap">
    <div id="emptyImage" class="d-flex justify-content-end">
        <button class="btn btn-dark text-light w-50" id="createbutton"  (click)="createProjectDisplay()">Create Project</button>
    </div>
</div>

<!-- Hidden for the moment -->
<div class="btn-group d-none justify-content-center">
    <button class="btn btn-light text-dark" (click)="showMoreLessProjects('m')">
        <i class="fas fa-angle-down"></i>
    </button>
    <button class="btn btn-light text-dark" (click)="showMoreLessProjects('l')">
        <i class="fas fa-angle-up"></i>
    </button>
</div>


<!-- Log In -->
<div class="modal fade" id="login">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-body p-4">
                <app-login></app-login>
            </div>
        </div>
    </div>
</div>

<!-- Change Password -->
<div class="modal fade" id="change">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-body">
                <change-password [userId]=userId></change-password>
            </div>
        </div>
    </div>
</div>
